/**
 * NoteModal (m-note) — Edit/expand note for a line item or quote-level note.
 *
 * Full text editor for notes that print on the quote.
 */

import React, { useState, useEffect } from 'react';
import Slideover from '../../../ui/Slideover';
import { Button } from '../../../ui/Button';

export default function NoteModal({ open, onClose, initialNote, itemLabel, onSave }) {
  const [note, setNote] = useState('');

  useEffect(() => {
    setNote(initialNote || '');
  }, [initialNote, open]);

  const handleSave = () => {
    onSave(note.trim());
    onClose();
  };

  const footer = (
    <div className="flex gap-2 justify-end w-full">
      <Button variant="secondary" onClick={onClose}>Cancel</Button>
      <Button onClick={handleSave}>Save Note</Button>
    </div>
  );

  return (
    <Slideover open={open} onClose={onClose} title="Edit Note" subtitle={itemLabel || 'Quote note'} footer={footer} width="sm">
      <div className="space-y-3">
        <p className="text-xs" style={{ color: 'var(--color-text-secondary)' }}>
          This note will appear on the printed quote.
        </p>
        <textarea
          value={note}
          onChange={(e) => setNote(e.target.value)}
          rows={8}
          className="w-full rounded-md border border-[color:var(--color-border)] px-3 py-2 text-sm resize-y"
          style={{
            borderColor: 'var(--color-border)',
            color: 'var(--color-text-primary)',
            backgroundColor: 'var(--color-surface)',
          }}
          placeholder="Add a note…"
          autoFocus
        />
        <p className="text-xs text-right" style={{ color: 'var(--color-text-secondary)' }}>
          {note.length} characters
        </p>
      </div>
    </Slideover>
  );
}
